export default "__VITE_ASSET__peHs1Y51__"